import { render, staticRenderFns } from "./JingquZiyuanFenxi.vue?vue&type=template&id=bd911ada&scoped=true&"
import script from "./JingquZiyuanFenxi.vue?vue&type=script&lang=js&"
export * from "./JingquZiyuanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd911ada",
  null
  
)

export default component.exports